/**
 * Collection card quick-add — same pattern as .promotional_information .copy:
 * div trigger + delegated click with stopPropagation so card link ::after does not win.
 */
(function () {
  function handleCollectionQuickAddClick(event) {
    const trigger = event.target.closest('.quick-add--collection-bar .quick-add__trigger');
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    const modalSelector = trigger.dataset.modal;
    if (modalSelector) {
      const modal = document.querySelector(modalSelector);
      if (modal && typeof modal.show === 'function') {
        modal.show(trigger);
      }
      return;
    }

    const productForm = trigger.closest('product-form');
    const submit = productForm?.querySelector('[type="submit"]');
    if (submit && !submit.disabled) {
      submit.click();
    }
  }

  function handleCollectionQuickAddKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('.quick-add--collection-bar .quick-add__trigger');
    if (!trigger) return;
    event.preventDefault();
    handleCollectionQuickAddClick(event);
  }

  document.addEventListener('click', handleCollectionQuickAddClick);
  document.addEventListener('keydown', handleCollectionQuickAddKeydown);
})();
